import Control from '../1. Core/Control';
import DataTable from '../1. Core/Controls/DataTable/DataTable';
import TopAppBar from '../1. Core/Controls/TopAppBar/TopAppBar';
import Delegate from '../1. Core/Delegate';
import './FantasyList.scss';
import {NewsSource} from './types';
import NP from "../1. Core/NP";
import {ServerAPI} from "../1. Core/ServerAPI";
import ListItem from "../1. Core/Controls/ListBox/ListItem";
import Menu from "../1. Core/Controls/Menu/Menu";
import IconToggleButton from "../1. Core/Controls/IconToggleButton/IconToggleButton";
import EditNewsSourceDialog from "./EditNewsSourceDialog";
import {PageMode} from "../10. Battle/types";
import NewsList from "./NewsList";


export default class NewsSourceList extends Control {
    private _topAppBar: TopAppBar;
    private EvShowPageModeClick: Delegate;

    private _dataTable: DataTable;
    private _dataWithFiltersNode: HTMLElement;
    private _ShowAppBar: boolean;
    private _drillDownPanel: NewsList;

    constructor(settings: object) {
        super(settings);
        this._render();
    }

    _initFields(settings: object) {
        this._ShowAppBar = true;
        this.EvShowPageModeClick = new Delegate();
        super._initFields(settings);
    }

    _render() {
        this.np_render();
        this.addClass('');


        if (this._ShowAppBar)
            this._topAppBar = new TopAppBar({
                Class: 'top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
                Caption: 'News',
                ParentNode: this._root,
                ShowSearchButton: false,
                MainButton: {
                    FontImage: NP.FontImages.menu,
                    EvClick: () => this.EvShowPageModeClick.fire(this)
                },
                RightItems: NP.getCurrentUser().isBDAdmin() ? [
                    new IconToggleButton({
                        FontImage: NP.FontImages.add,
                        EvClick: () => {
                            new EditNewsSourceDialog({EvOkButtonClick: () => this.refreshList()}).show();
                        }
                    }),
                ] : [],
                EvBackClick: () => {
                    NP.updateBrowserUrlString(true, PageMode.newssource);
                    NP.showNode(this._dataTable.getRoot());
                    this._drillDownPanel.destroy();
                    this._drillDownPanel = null;
                    this._topAppBar.setShowBackButton(false)
                }
            });

        this._dataWithFiltersNode = NP.createNode(this._root, 'data-with-filters-container');


        this._dataTable = new DataTable({
            ParentNode: this._dataWithFiltersNode,
            ShowSettingsButton: NP.getCurrentUser().isBDAdmin(),
            Class: 'app-list--avatars mdc-data-table--margin data-table-battle',
            MultiSelect: false,
            ShowRowIndex: false,
            EnableSort: false,
            ImageWidth: 32,
            Columns: [{
                Content: 'Id',
                Width: '10%',
                PropertyContent: 'Id'
            }, {
                Content: NP.RM.getString('Name'),
                PropertyContent: 'Name',
                Width: '20%'
            }, {
                Width: '40%',
                Content: 'Url',
                PropertyContent: 'RSSUrl'
            }, {
                Content: 'Type',
                PropertyContent: 'Type',
                Width: '15%'
            }],
            ShowPaginator: false,
            EvItemClick: (s: object, e: { Item: NewsSource }) => {
                this.showNewsList(e.Item)
            },
            EvSortClick: (s: DataTable, e: any) => {
                e.CanceSort = true;


                this.refreshList();
            },
            EvItemContextMenu: async (s: any, e: { Event: any, Item: NewsSource }) => {
                if (!NP.getCurrentUser().isBDAdmin())
                    return;

                let menu = new Menu({
                    Items: [{
                        FontImage: NP.FontImages.edit,
                        RK: 'Edit',
                        Value: 'Edit',
                    }, {
                        FontImage: NP.FontImages.refresh,
                        Content: 'Reload',
                        Value: 'Reload',
                    }, {
                        FontImage: NP.FontImages.delete,
                        RK: 'Remove',
                        Value: 'Remove',
                    }],
                    EvItemSelected: async (s: Menu, event: { Item: ListItem }) => {

                        switch (event.Item.getValue()) {
                            case 'Edit':
                                new EditNewsSourceDialog({
                                    NewsSource: e.Item,
                                    EvOkButtonClick: () => this.refreshList()
                                }).show()
                                break
                            case 'Reload':
                                await ServerAPI.post(`/news-source/${e.Item.Id}/reload`);
                                break
                            case 'Remove':
                                NP.showConfirm({
                                    Content: NP.RM.getString('AreYouS'),
                                    EvOkButtonClick: async () => {
                                        await ServerAPI.callUiApi("/news-source/" + e.Item.Id, null, 'DELETE');
                                        this.refreshList();
                                    }
                                })
                                break
                        }


                    }
                });
                menu.showContextMenu(e.Event);
            }
        });
    }

    showNewsList(source: NewsSource) {
        NP.updateBrowserUrlString(true, PageMode.newssource, source.Id);

        NP.hideNode(this._dataTable.getRoot());

        this._drillDownPanel = new NewsList({
            ParentNode: this._dataWithFiltersNode,
            Width: this._Width,
            Height: this._Height,
            SourceId: source.Id,
        })

        this._topAppBar.setShowBackButton(true)
        this._drillDownPanel.setWidth(this._Width);
    }


    setHeight(value: number) {
        super.setHeight(value);
        let h = this._Height - (this._topAppBar ? this._topAppBar.getOffsetHeight() : 0);
        this._dataTable.setHeight(h);
        this._drillDownPanel?.setHeight(h);
    }

    setWidth(value: number) {
        super.setWidth(value);
        this._dataTable.setWidth(value);
        if (this._dataTable.getIsSmall()) {
            if (this._topAppBar)
                this._topAppBar.removeClass('top-app-bar--no-shadow');
            this.setHeight(this._Height);
        } else {
            if (this._topAppBar)
                this._topAppBar.addClass('top-app-bar--no-shadow');
            this.setHeight(this._Height);
        }

        this._drillDownPanel?.setWidth(value);
    }

    refresh() {
        this.refreshList();
    }

    private async refreshList() {
        let sources = await ServerAPI.get<NewsSource[]>("/news-source")

        this._dataTable.setRows(sources);
    }

    getTopAppBar() {
        return this._topAppBar;
    }
}